import {
  GET_SCHEDULED_REPORTS,
  GET_SCHEDULED_REPORTS_SUCCESS,
  GET_SCHEDULED_REPORTS_ERROR,
  CREATE_SCHEDULED_REPORTS,
  CREATE_SCHEDULED_REPORTS_SUCCESS,
  CREATE_SCHEDULED_REPORTS_ERROR,
  UPDATE_SCHEDULED_REPORTS,
  UPDATE_SCHEDULED_REPORTS_SUCCESS,
  UPDATE_SCHEDULED_REPORTS_ERROR,
  DELETE_SCHEDULED_REPORTS,
  DELETE_SCHEDULED_REPORTS_SUCCESS,
  DELETE_SCHEDULED_REPORTS_ERROR,
  RESET_LAST_SCHEDULED_REPORTS_ACTION,
  GET_SCHEDULED_REPORT_LOGS_BY_ID,
  GET_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS,
  GET_SCHEDULED_REPORT_LOGS_BY_ID_ERROR,
  REDIRECT_TO_DOWNLOAD_URL,
  REDIRECT_TO_DOWNLOAD_URL_SUCCESS,
  REDIRECT_TO_DOWNLOAD_URL_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  scheduled_reports: [],
  loading: false,
  update_scheduled_report_loading: false,
  last_scheduled_reports_action: null,
  // Object with key: scheduled_report_id
  // value: Object with logs (logs array), title (report title)
  scheduled_report_logs: {},
  redirect_to_download_url: "",
  redirect_to_download_url_loading: false,
  redirect_to_download_url_error: null,
}

const ScheduledReports = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULED_REPORTS:
      return {
        ...state,
        loading: true,
        last_scheduled_reports_action: null
      }

    case GET_SCHEDULED_REPORTS_SUCCESS:
      return {
        ...state,
        scheduled_reports: action.payload,
        loading: false
      }

    case GET_SCHEDULED_REPORTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_SCHEDULED_REPORTS:
      return {
        ...state,
        loading: true
      }

    case CREATE_SCHEDULED_REPORTS_SUCCESS:
      return {
        ...state,
        scheduled_reports: [...state.scheduled_reports, ...action.payload],
        loading: false,
        last_scheduled_reports_action: action.type,
      }

    case CREATE_SCHEDULED_REPORTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_SCHEDULED_REPORTS:
      return {
        ...state,
        loading: true,
        update_scheduled_report_loading: true
      }

    case UPDATE_SCHEDULED_REPORTS_SUCCESS:
      return {
        ...state,
        scheduled_reports: state.scheduled_reports.map(scheduled_report => {
          const same_rpt_in_payload = action.payload.find(payload_rpt => payload_rpt.id === scheduled_report.id);
          if (same_rpt_in_payload) {
            return same_rpt_in_payload;
          }

          return scheduled_report;
        }),
        loading: false,
        update_scheduled_report_loading: false,
        last_scheduled_reports_action: action.type,
      }

    case UPDATE_SCHEDULED_REPORTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        update_scheduled_report_loading: false,
      }

    case DELETE_SCHEDULED_REPORTS:
      return {
        ...state,
        loading: true
      }

    case DELETE_SCHEDULED_REPORTS_SUCCESS:
      return {
        ...state,
        scheduled_reports: state.scheduled_reports.filter(scheduled_report => scheduled_report.id != action?.payload[0]?.id),
        loading: false,
        last_scheduled_reports_action: action.type,
      }

    case DELETE_SCHEDULED_REPORTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_SCHEDULED_REPORT_LOGS_BY_ID:
      return {
        ...state,
        error: null,
        loading: true
      }

    case GET_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        scheduled_report_logs: {
          ...state.scheduled_report_logs,
          [action.scheduled_report_id.toString()]: {
            logs: action?.payload?.data,
            title: action?.payload?.additional_data?.title
          }
        }
      }

    case GET_SCHEDULED_REPORT_LOGS_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case REDIRECT_TO_DOWNLOAD_URL:
      return {
        ...state,
        redirect_to_download_url_loading: true,
      }

    case REDIRECT_TO_DOWNLOAD_URL_SUCCESS:
      return {
        ...state,
        redirect_to_download_url_loading: false,
        redirect_to_download_url: action?.payload,
      }

    case REDIRECT_TO_DOWNLOAD_URL_ERROR:
      return {
        ...state,
        redirect_to_download_url_loading: false,
        redirect_to_download_url_error: action.payload,
      }

    case RESET_LAST_SCHEDULED_REPORTS_ACTION:
      return {
        ...state,
        last_scheduled_reports_action: null,
        redirect_to_download_url: "",
        error: null,
      };

    default:
      return state
  }
}

export default ScheduledReports;
